import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {countryConfig} from 'src/country-config/country-config';
import {RequestService} from '../../../handlers/request/request.service';
import {brazeApi, brazeEndpoints} from '../../api/braze/braze.api';
import { ContentCardsResponse } from '../../models/braze/content-cards';
import { FieldsExportBraze, FieldsExportBrazeResponse } from '../../models/braze/api-rest';
import { globalEnv } from '../../connection/global/global.env';

const apikey = {'Authorization' : `Bearer ${countryConfig.braze.apiKey}`}

@Injectable({
  providedIn: 'root',
})
export class BrazeService {
  constructor(private req: RequestService) {}

  get(data?): Observable<any> {
    const url = `${brazeApi.host}${brazeApi.users}`;
    return this.req.post(url, data, null, false, null, false, brazeApi.token_production);
  }

  getContentCardsApi(data?): Observable<ContentCardsResponse> {
    data.api_key = countryConfig.braze.apiKey;
    data.sdk_version = '5.0.1';
    data.last_full_sync_at = 1;
    data.last_card_updated_at = 0;
    const url = `${brazeApi.host}${brazeEndpoints.contentCards}`;
    return this.req.post(url, data, null, false, null, false, brazeApi.token_production);
  }

  getUserData(data: FieldsExportBraze): Observable<FieldsExportBrazeResponse> {
    const url = `${globalEnv.cloudFunction}${brazeEndpoints.cloudFunction}`;
    return this.req.post(url, data, null, false, null, false, null);
  }
}
